<template>
   <vue-final-modal
      v-model="inputFormModal" 
      classes="modal-container"
      content-class="input-form-modal-content"
      @opened="opened()"
      @click-outside="beforeClose()"
      @before-open="beforeOpen()"
      >
      <button 
         id="first_if"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="beforeClose()"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white row row-cols-auto">
         <card-rectangle :rectangleCard="oCardType" class="col mt-1"/>
         <div v-if=" oDataFromCard.typeForm == 'T' " class="col pe-1">Título de la tarjeta</div>
         <div v-else class="col pe-1"> {{ oDataFromCard.extensionName }} </div>
      </span>
      <div class="multi-card p-0 pb-1 mt-1 border-top">
         <div class="container">
            <Form
               @submit="formSubmit"
               :validation-schema="formSchema"
               :initial-values="initialFormValues"
               keep-values
               >
               <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('last_if').focus()"></div>
               <!--
               <pre>{{dataFiels}}</pre>
            <pre>{{ JSON.parse(cardType.titleParameters).input }}</pre>
                  v-slot="{ values }"
                  :initial-values="dataVoucher"
               <pre>{{ v310Object }}</pre>
               <div v-for="(rectangleCard, index) in cellCards" :key="index" 
               <pre>{{ cardType }}</pre>
               -->

               <div v-for=" (field, index) in  fieldArray" :key="index"
                  class="row"
                  >
                  <div v-if="field == 'txt_free'" class="col-12 p-0 m-0">
                     <textarea-field :fieldData="formCnf.textFree" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        />
                  </div>
                  <div v-if="field == 'date_req'" class=" col-7 p-0 m-0">
                     <common-field :fieldData="formCnf.requestDate" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        />
                  </div>
                  <!-- auth -->
                  <div v-if="field == 'authorization'" class=" col-7 p-0 m-0">
                     <common-field :fieldData="formCnf.authorization" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        />
                  </div>
                  <div v-if="field == 'valid_from' && dataFiels.requestFrom" 
                        class=" col-7 p-0 m-0">
                     <common-field :fieldData="formCnf.dateFrom" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        />
                  </div>
                  <div v-if="field == 'valid_until' && !( dataFiels.requestFrom && !dataFiels.byHand)" 
                        class=" col-7 p-0 m-0">
                     <common-field :fieldData="formCnf.dateUntil" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        />
                  </div>
                  <!--
                  -->
                  <!-- -->
                  <div v-if="field == 'reference'" class=" col-12 p-0 m-0">
                     <special-button-field :fieldData="formCnf.reference" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        :newValue="newReferenceValue"
                        :changeValue="changeReferenceValue"
                        :readonly="true"
                        @onButtonClick="searchReference = true"
                        >
                        <font-awesome-icon v-if="oCardType.referenceType != 'ID'" icon="search" class="tx-cl-white"/>
                     </special-button-field>
                  </div>
                  <!-- -->
                  <div v-if="field == 'afl_email' && oStartedBy != 'MPV'" class=" col-12 p-0 m-0">
                     <special-button-field :fieldData="formCnf.aflEmail" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        :newValue="newEmailValue"
                        :changeValue="changeEmailValue"
                        @onButtonClick="searchEmail = true"
                        >
                        <font-awesome-icon icon="search" class="tx-cl-white"/> 
                     </special-button-field>
                  </div>
                  <!--  
                        :resetButton="'resetCuil'"
                  -->
                  <div v-if="field == 'afl'" class=" col-7 p-0 m-0">
                     <special-button-field :fieldData="formCnf.cuil" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        :newValue="newCuilValue"
                        :changeValue="changeCuilValue"
                        @onButtonClick="searchAffil = true "
                        @onBlur="onBlurCuit = true" 
                        @onFocus="onBlurCuit = false" 
                        >
                        <font-awesome-icon icon="search" class="tx-cl-white"/> 
                     </special-button-field>
                  </div>
                  <affiliate-data v-if="field == 'afl' && validCuil"
                     :dataAffiliate="dataAffil" 
                     class="col-12 rounded border mt-1"
                     />
                  <!--
                        :newValue="newCuilValue"
                        :changeValue="changeCuilValue"
                        @onButtonClick="searchAffil = true "
                        @onBlur="onBlurCuit = true" 
                        @onFocus="onBlurCuit = false" 
                  -->
                  <div v-if="field == 'requestMedProv' && oStartedBy != 'AFL'" class=" col-12 p-0 m-0">
                     <special-button-field :fieldData="formCnf.codeRequestMedProv" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        :newValue="newCodeReqMedProvValue"
                        :changeValue="changeCodeReqMedProvValue"
                        @onButtonClick="findMedProv( '', 'Req')"
                        @onBlur="onBlurReqMedProv = true" 
                        @onFocus="onBlurReqMedProv = false" 
                        >
                        <font-awesome-icon icon="search" class="tx-cl-white"/> 
                     </special-button-field>
                  </div>
                  <medical-provider-data v-if="field == 'requestMedProv' && objReqMedProv != null"
                     :data="objReqMedProv"
                     class="col-12 rounded border mt-1"
                  />
                  <!-- 
                  -->
                  <div v-if="field == 'medProv_email' && oStartedBy != 'AFL'" class=" col-12 p-0 m-0">
                     <special-button-field :fieldData="formCnf.mpEmail" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        :newValue="newMedProvEmailValue"
                        :changeValue="changeMedProvEmailValue"
                        @onButtonClick="searchMedProvEmail = true"
                        >
                        <font-awesome-icon icon="search" class="tx-cl-white"/> 
                     </special-button-field>
                  </div>
                  <!-- designated -->
                  <div v-if="field == 'designatedMedProv'" class=" col-12 p-0 m-0">
                     <special-button-field :fieldData="formCnf.codeDesignatedMedProv" 
                        :tabindex="tabIndexNumber( index + 3 )" 
                        :id=" field "
                        :newValue="newCodeDesMedProvValue"
                        :changeValue="changeCodeDesMedProvValue"
                        @onButtonClick="findMedProv( '', 'Des')"
                        @onBlur="onBlurDesMedProv = true" 
                        @onFocus="onBlurDesMedProv = false" 
                        >
                        <font-awesome-icon icon="search" class="tx-cl-white"/> 
                     </special-button-field>
                  </div>
                  <medical-provider-data v-if="field == 'designatedMedProv' && objDesMedProv != null"
                     :data="objDesMedProv"
                     class="col-12 rounded border mt-1"
                  />
                  <!--
                  <medical-provider-data v-if="field == 'requestMedProv' && okCodeReqMedProv"
                  <div v-if="field == 'requestMedProv'" class=" col-12 p-0 m-0">
                     {{objReqMedProv}}
                  </div>
                  -->
               </div>
               <div class="row p-0 mt-1 justify-content-between border-top">
                  <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
                  <div class="d-flex justify-content-end pt-2 px-0 col-10">
                     <button type="submit" 
                           :tabindex="tabIndexNumber( fieldArray.length + 3 )" 
                           class="btn btn-outline-light btn-sm me-1" 
                           >
                        {{ btnSubmitName }}
                     </button>
                     <button type="button" 
                           id="last_if"
                           :tabindex="tabIndexNumber( fieldArray.length + 4 )" 
                           class="btn btn-outline-light btn-sm me-1" 
                           @click="beforeClose()"
                           >
                        Salir
                     </button>
                     <div :tabindex="tabIndexNumber( fieldArray.length + 5 )" onfocus="document.getElementById('first_if').focus()"></div>
                  </div>
               </div>
            </Form>
            <!--
            -{{medProvEmail}}-
            <br>
            {{objReqMedProv}}
            {{cardTypeReferences}}
            <br>
            {{dataFiels}}
            <br>
            {{oCardType}}
            -->
         </div>
      </div>
      <!-- llamada al modal del contenido -->
      <button v-show="false" 
         type="button" class="btn btn-sm btn-card"  
         data-bs-toggle="modal" data-bs-target="#mdContent" 
         :data-cntt-id="contentId" 
         :data-cell-id="cellId"
         :data-cellContent-id="cellContentId"
         ref="btnEdit"
         >
      </button>
   </vue-final-modal>
   <search-affiliate v-if="searchAffil"
      @cancel="searchAffil = false"
      @cuil="(val) => upCuil(val)"
      />
   <search-medical-provider v-if="searchMedProv"
      :optionIndex="optionIndex"
      :textToSearch="textToSearch"
      @cancel="searchMedProv = false"
      @item="(val) => upItemMedProv(val)"
      />
   <show-title v-if="showTitle"
      :cardType="oCardType"
      :title="title"
      :contentId="Number(oDataFromCard.cardId)"
      @cancel="showTitle = false"
      @update="upTitle()"
      />
   <affiliate-emails-select  v-if="searchEmail"
      :affilId="Number(affilId)"
      :email="affilEmail"
      @cancel="searchEmail = false"
      @selected="(val) => upEmail(val, true)"
      />
   <references-select  v-if="searchReference"
      :referenceType="oCardType.referenceType"
      :references="cardTypeReferences"
      @cancel="searchReference = false"
      @check="(val) => cardTypeReferences[val].selected = !cardTypeReferences[val].selected"
      @selected="upReference()"
      />
   <medical-provider-emails-select v-if="searchMedProvEmail"
      :medProvId="Number(reqMedProvId)"
      :email="medProvEmail"
      @cancel="searchMedProvEmail = false"
      @selected="(val) => upMedProvEmail(val, true)"
      />
   <do-not-close  v-if="doNotClose"
      :messages="[
            'No cierre esta pantalla, espere a que vuelva a aparecer la pantalla anterior.',
            'Esto permitirá terminar correctamente esta operación.'
            ]"
      @onOpened="newUpForm()"
      />
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick, watch } from 'vue';
import { useStore } from 'vuex'
import { Form, defineRule } from 'vee-validate';
import { useRouter } from 'vue-router'
import * as yup from 'yup';
import moment from 'moment';

import WspService from '../../workSpace.service';
import AnalyService from '../../../analytics/analytics.service';
import { validCuilNumber, validCuilAffil, findBasicAffilData } from '../../../analytics/analytics.util.js'

import UserCircle from '../../../../components/UserCircle.vue';
import CardRectangle from '../CardRectangle.vue';
import AffiliateData from '../../../analytics/components/affiliate/AffiliateDataShow.vue';
import commonField from '../../../voucher310/components/CommonField.vue';
import textareaField from '../../../voucher310/components/TextareaField.vue';
import SpecialButtonField from '../../../voucher310/components/SpecialButtonField.vue';
import MedicalProviderData from '../../../analytics/components/medicalProvider/MedicalProviderDataShow.vue';

import AffiliateEmailsSelect from './AffiliateEmailsSelect.vue';
import ReferencesSelect from './ReferencesSelect.vue';
import SearchAffiliate from '../../../analytics/components/affiliate/SearchAffiliate.vue';
import SearchMedicalProvider from '../../../analytics/components/medicalProvider/SearchMedicalProvider.vue';
import MedicalProviderEmailsSelect from './MedicalProviderEmailsSelect.vue';
import ShowTitle from './ShowTitle.vue';
import DoNotClose from './DoNotClose.vue';

export default {

   components: {
      AffiliateData,
      AffiliateEmailsSelect,
      CardRectangle,
      commonField,
      DoNotClose,
      Form,
      MedicalProviderData,
      MedicalProviderEmailsSelect,
      ReferencesSelect,
      SearchAffiliate,
      SearchMedicalProvider,
      ShowTitle,
      SpecialButtonField,
      textareaField,
      UserCircle,
      VueFinalModal
   },
   
   props: {
      cardType: Object,
      cellId: Number,
      startedBy: String,
      dataFromCard: {
         type: String,
         default: '{"cardId":0}'
      }
   },
   
   emits: [ 'cancel' ],

   setup(props, { emit }) {
   //setup( props ) {

      defineRule('dfrValidCuil', value => {

         if ( value === undefined && ( searchAffil.value || !onBlurCuit.value ) ) { 
            return true 
         }
         if ( validCuil.value && onBlurCuit.value ) {
            return true
         }
         validCuil.value = false
         affilEmail.value = null

         let validNumber = validCuilNumber( value )
         if ( typeof( validNumber ) == "boolean" ) {
            return validAffil( value )
         }
         return validNumber
      })

      defineRule('dfrValidAuthorization', value => {

         if ( isNaN( value ) ) { return 'Debe ser un número!' }
         if ( value < 0) { return 'Debe ser mayor o igual a cero!' }
         if ( parseInt( value ) != value ) { return 'Debe ser un número entero!' }

         return dfrValidAuth ( value )
         //return dfrValidDrug310( value )
      });

      defineRule('dfrCodeRequestMedProv', value => {

         console.log(value)
         console.log(searchMedProv.value)
         console.log(onBlurReqMedProv.value)
         console.log(objReqMedProv.value)
         if ( value === undefined && ( searchMedProv.value || !onBlurReqMedProv.value ) ) { 
            return true 
         }
         if ( objReqMedProv.value !=null && onBlurReqMedProv.value ) {
            return true
         }
         objReqMedProv.value = null
         medProvEmail.value = null
         //
         console.log(newCodeReqMedProvValue.value)
         console.log(initialCodeReqMedProvValue.value)
         /*
         if ( oDataFromCard.value.cardId > 0 ) {
            if ( initialCodeReqMedProvValue.value == value ) {
               okCodeReqMedProv.value = true
               return true
            }
         } else {
            if ( newCodeReqMedProvValue.value == value ) {
               okCodeReqMedProv.value = true
               return true
            }
         }
         */
         okCodeReqMedProv.value = false

         if ( value === undefined ) { return 'Dato requerido!' }
         if ( value == null ) { return 'Dato requerido!' }
         if ( value.trim() == "" ) { return 'Dato requerido!' }

         return validCodeMedProv( value, 'Req' )

         //return dfrValidDrug310( value )
      });

      defineRule('dfrCodeDesignatedMedProv', value => {

         if ( !onBlurDesMedProv.value ) { 
            return true 
         }
         console.log(newCodeDesMedProvValue.value)
         //console.log(initialCodeReqMedProvValue.value)

         if ( value === undefined ) { return 'Dato requerido!' }
         if ( value == null ) { return 'Dato requerido!' }
         if ( value.trim() == "" ) { return 'Dato requerido!' }

         return validCodeMedProv( value, 'Des' )
      });

      const initialTabIndex = ref(180)
      const inputFormModal = ref(true)
      const myCircle = ref({})
      const store = useStore()

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })
      const boardId = ref(WspService.getBoardId(store))

      const fieldArray = ref([])

      const formCnf = ref({})
      const formSchema = ref({})
      
      const onBlurCuit = ref(true)
      const validCuil = ref(false)
      const affilId = ref(0)
      const affilEmail = ref(null)
      const dataAffil = ref({})
      const searchAffil = ref(false)
      const searchMedProv = ref(false)
      const searchEmail = ref(false)
      const searchReference = ref(false)
      const newCuilValue = ref('')
      const changeCuilValue = ref(false)
      const newCodeReqMedProvValue = ref('')
      const newCodeDesMedProvValue = ref('')
      const initialCodeReqMedProvValue = ref('')
      const changeCodeReqMedProvValue = ref(false)
      const changeCodeDesMedProvValue = ref(false)
      const newEmailValue = ref('')
      const changeEmailValue = ref(false)
      const newReferenceValue = ref('')
      const changeReferenceValue = ref(false)
      const showTitle = ref(false)
      const title = ref('')
      const cardTypeReferences = ref([])
      const cellContentId = ref(0)
      const btnEdit = ref(null)
      const contentId = ref(0)
      const dataForm = ref({})

      const router = useRouter()
      const oDataFromCard = ref({})
      const oCardType = ref({})
      const initialFormValues = ref({})
      const dataFiels = ref({})
      const fthWatchAffId = ref(true)

      const btnSubmitName = ref('Ver Título')

      //const objReqMedProv = ref({})
      const objReqMedProv = ref(null)
      const objDesMedProv = ref(null)
      const okCodeReqMedProv = ref(false)
      const onBlurReqMedProv = ref(true)
      const onBlurDesMedProv = ref(false)
      const optionIndex = ref(1)
      const textToSearch = ref('')
      const typeMedProv = ref('')
      const searchMedProvEmail = ref(false)
      const reqMedProvId = ref(0)
      const fthWatchMedProvId = ref(true)
      const newMedProvEmailValue = ref('')
      const changeMedProvEmailValue = ref(false)
      const medProvEmail = ref(null)
      const oStartedBy = ref('AFL')

      const doNotClose = ref(false)
      let typeUpForm = ''

      let fieldFocus = ''
      let firstField = false

      //watch( affilId, ( newAffId, oldAffId ) => {
      watch( affilId, () => {
         //console.log( newAffId )
         if ( !fthWatchAffId.value ) {
            upEmail( '', false )
         }
         fthWatchAffId.value = false
         //console.log( oldAffId )  
      })

      watch( reqMedProvId, () => {
         //console.log( newAffId )
         if ( !fthWatchMedProvId.value ) {
            upMedProvEmail( '', false )
         }
         fthWatchMedProvId.value = false
      })

      async function dfrValidAuth( value ) {
         //console.log(value)

         let promise = new Promise(( resolve ) => {

            if ( value == 0 ) {
               resolve ( true )
            } else {
               WspService.existsAuthorization( oDataFromCard.value.cardId, value )
                  .then(response => {
                     if ( response.data ) {
                        resolve( 'Número ya ingresado!' )
                     } else {
                        resolve( true )
                     }
                  })
                  .catch(error => {
                     console.log(error);
                     resolve( 'Error de red!' )
               })
            }
         })
         return await promise
      }

      async function validCodeMedProv( value, typeMed ) {
         //console.log(value)

         let currentMedProvId = 0
         if ( typeMed == 'Req' && objReqMedProv.value != null && objReqMedProv.value.id != null ) {
            currentMedProvId = objReqMedProv.value.id
         }
         if ( typeMed == 'Des' && objDesMedProv.value != null && objDesMedProv.value.id != null ) {
            currentMedProvId = objDesMedProv.value.id
         }

         let promise = new Promise(( resolve ) => {

               AnalyService.countMedicalProviderByCode( value, currentMedProvId )
                  .then(response => {
                     resolve( response.data )
                  })
                  .catch(error => {
                     console.log(error);
                     resolve( 'Error de red!' )
               })
         })
         
         let result = await promise
         //objReqMedProv.value = {}
         if ( typeMed == 'Req' ) {
            reqMedProvId.value = 0
            medProvEmail.value = null
            objReqMedProv.value = null
            //okCodeReqMedProv.value = false
            if ( result.countByCode == 0 ) {
               newCodeReqMedProvValue.value = ''
               return 'Código inexistente!'
            }
            if ( result.countByCode == 1 ) {
               objReqMedProv.value = result
               reqMedProvId.value = objReqMedProv.value.id
               medProvEmail.value = objReqMedProv.value.email
               console.log(medProvEmail.value)
               //okCodeReqMedProv.value = true
               return true
            }
         }
         if ( typeMed == 'Des' ) {
            objDesMedProv.value = null
            if ( result.countByCode == 0 ) {
               newCodeDesMedProvValue.value = ''
               return 'Código inexistente!'
            }
            if ( result.countByCode == 1 ) {
               objDesMedProv.value = result
               return true
            }
         }
         findMedProv( value, typeMed )
         return true
      }

      //async function upTitle() {
      function upTitle() {
         if ( initialTabIndex.value > 100 ) {
            doNotClose.value = true
            if ( oDataFromCard.value.cardId == 0 ) {
               typeUpForm = 'New'
            } else {
               typeUpForm = 'Update'
            }
         } else {
         if ( oDataFromCard.value.cardId == 0 ) {

            WspService.addContent(
               currentUserId.value, // userId,
               boardId.value,       // boardId, 
               props.cellId,        // cellId,
               oCardType.value.id,  // cardTypeId,
               title.value          // title
               )
            .then(response => {
               contentId.value = response.data
               //
               WspService.getCellContent(props.cellId, contentId.value)
               .then(response => {
                  console.log(response.data.id);
                  cellContentId.value = response.data.id
                  //
                  updateForm( contentId.value, 'New' )
                  //
                  nextTick(() => { 
                     btnEdit.value.click() 
                     emit('cancel')
                  })
                  /*
                  setTimeout( () => {
                     btnEdit.value.click() 
                     emit('cancel')
                  }, 500 )
                  */
               })
               .catch(error => { console.log(error) });
            })
            .catch(error => { console.log(error) });
            /*
            */
         } else {

            let cnttData = {}
               cnttData.columnId = 0   //columnId.value
               cnttData.userId = currentUserId.value
               cnttData.title = title.value
            WspService.upContent(
               oDataFromCard.value.cardId,    // contentId,
               oDataFromCard.value.cellId,    // cellId,
               boardId.value,  // boardId
               'TTL',   // code
               cnttData    // cnttData
               )
            .then(response => {
               console.log("upContent Id: "+response.data)
               if ( response.data > 0 ) {
                  //getAllContent(response.data)
                  store.dispatch("wspace/setContentId", -16)
               }
            })
            .catch(error => { console.log(error) });

            if ( dataFiels.value.title.trim() !== title.value.trim() ) {
               updateForm( oDataFromCard.value.cardId, 'Update' )
            }
            beforeClose()
         }
         }
      }

      function setDataForm( contentId, newUpdate ) {
         dataForm.value.boardId = boardId.value
         dataForm.value.cellId = oDataFromCard.value.cellId
         dataForm.value.userId = currentUserId.value
         //
         dataForm.value.contentId = contentId
         dataForm.value.newUpdate = newUpdate
         dataForm.value.referenceIds = []
         for (let reference of cardTypeReferences.value ) {
            if ( reference.selected ) {
               dataForm.value.referenceIds.push( reference.id )
            }
         }
         dataForm.value.startedBy = oStartedBy.value
         console.log(dataForm.value)
      }

      function updateForm( contentId, newUpdate ) {
         return new Promise( () => {
            //
            dataForm.value.boardId = boardId.value
            dataForm.value.cellId = oDataFromCard.value.cellId
            dataForm.value.userId = currentUserId.value
            //
            dataForm.value.contentId = contentId
            dataForm.value.newUpdate = newUpdate
            dataForm.value.referenceIds = []
            for (let reference of cardTypeReferences.value ) {
               if ( reference.selected ) {
                  dataForm.value.referenceIds.push( reference.id )
               }
            }
            console.log(dataForm.value)
            WspService.updateForm(dataForm.value)
            .then( () => {
               if ( newUpdate == "Form" ) {
                  if ( oDataFromCard.value.extensionCode == 'VALID' ) {
                     store.dispatch("wspace/setContentId", -15)
                  }
                  if ( oDataFromCard.value.extensionCode == 'AUTH' ) {
                     store.dispatch("wspace/setContentId", -19)
                  }
                  if ( oDataFromCard.value.extensionCode == 'MPRQ' ) {
                     store.dispatch("wspace/setContentId", -20)
                  }
                  if ( oDataFromCard.value.extensionCode == 'MPDS' ) {
                     store.dispatch("wspace/setContentId", -21)
                  }
               }
            })
            .catch(error => { console.log(error) })
            //
            showTitle.value = false
            /*
            WspService.getFormValues( oDataFromCard.value.cardId )
            .then(response => { resolve ( response.data )})
            .catch(error => { console.log(error) })
            */
         })
      }

      function addInitialValues( key, value ) {
         if ( oDataFromCard.value.cardId > 0 ) {
            initialFormValues.value[key] = dataFiels.value[value]
            console.log( key + ' - ' + value)
         }
         firstField = true
      }

      function beforeClose() {
         if ( oDataFromCard.value.cardId == 0 || oDataFromCard.value.typeForm == 'F') {
            emit('cancel')
         } else {
            nextTick(() => {
               router.go(-1)
            })
         }
      }

      async function beforeOpen() {
         
         oCardType.value = await getCardType()
         oStartedBy.value = props.startedBy
         
         if ( oDataFromCard.value.cardId > 0 ) {
            dataFiels.value = await getFormValues()
            affilId.value = dataFiels.value.affiliateCuil
            reqMedProvId.value = dataFiels.value.requestMedProvId
            initialCodeReqMedProvValue.value = dataFiels.value.codeRequestMedProv
            oStartedBy.value = dataFiels.value.startedBy
         }

         let labelDateUntil = 'Fecha hasta'
         if ( dataFiels.value.toName != '' ) {
            labelDateUntil = dataFiels.value.toName
         }
         
         formCnf.value = {
            aflEmail: {
               name: 'aflEmail',
               label: 'Email del Afiliado',
               type: 'text'
            },
            cuil: {
               name: 'cuil',
               label: 'C.U.I.L. del Afiliado',
               type: 'text'
            },
            reference: {
               name: 'reference',
               label: 'Referencia',
               type: 'text'
            },
            requestDate: {
               name: 'requestDate',
               label: 'Fecha de Solicitud',
               type: 'date'
            },
            textFree: {
               name: 'textFree',
               label: 'Texto'
            },
            dateFrom: {
               name: 'dateFrom',
               label: 'Fecha desde',
               type: 'date'
            },
            dateUntil: {
               name: 'dateUntil',
               label: labelDateUntil,
               type: 'date'
            },
            authorization: {
               name: 'authorization',
               label: 'Nro. Autoriz/Docum',
               type: 'text'
            },
            codeRequestMedProv: {
               name: 'codeRequestMedProv',
               label: 'Código Prestador Solicitante',
               type: 'text'
            },
            codeDesignatedMedProv: {
               name: 'codeDesignatedMedProv',
               label: 'Código Prestador Designado',
               type: 'text'
            },
            mpEmail: {
               name: 'mpEmail',
               label: 'Email del Prestador',
               type: 'text'
            }
         }

         console.log(oDataFromCard.value.typeForm)
         if ( oDataFromCard.value.typeForm == 'T' ) {
            fieldArray.value = JSON.parse(oCardType.value.titleParameters).input
         } else {
            fieldArray.value = JSON.parse(oDataFromCard.value.formParameters).input
            btnSubmitName.value = 'Aceptar'
         }
         console.log(fieldArray.value)
         //
         for (let field of fieldArray.value) {
            //console.log(field)
            if (field == 'afl') {
               addInitialValues( 'cuil', 'affiliateCuil')
               formSchema.value.cuil = 'dfrValidCuil'
            }
            if (field == 'afl_email' && oStartedBy.value != 'MPV') {
               addInitialValues( 'aflEmail', 'affiliateEmail')
               if ( oStartedBy.value == 'AFL' ) {
                  formSchema.value.aflEmail = yup.string()
                     .email('Dirección de email inválida!')
                     .required('Dato Requerido!')
               } else {
                  formSchema.value.aflEmail = yup.string()
                     .email('Dirección de email inválida!')
                     .nullable()
               }
            }
            if (field == 'date_req') {
               addInitialValues( 'requestDate', 'requestDate')
               formSchema.value.requestDate = yup.date()
                  .required('Dato Requerido!')
                  .typeError( 'Fecha Inválida!' )
                  .max(moment(new Date()).format('YYYY-MM-DD'), 'Fecha mayor al día de hoy!')
                  .min(moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD'),
                     'La Fecha debe ser posterior al '+moment(new Date()).subtract(1, 'month').format('DD-MM-YYYY')+'!')
            }
            if (field == 'txt_free') {
               addInitialValues( 'textFree', 'freeText')
               formSchema.value.textFree = yup.string().nullable()
            }
            if (field == 'reference') {
               formSchema.value.reference = yup.string().required('Dato Requerido!')

               WspService.getMyCardReferences( oCardType.value.id, oDataFromCard.value.cardId )
               .then(response => {
                  cardTypeReferences.value = response.data
                  nextTick(() => {
                     upReference()
                  })
               })
               .catch(error => { console.log(error) })
            }
            // auth
            if (field == 'authorization') {
               addInitialValues( 'authorization', 'authorizationNumber')
               formSchema.value.authorization = 'dfrValidAuthorization'
            }
            if (field == 'valid_from' && dataFiels.value.requestFrom) {
               addInitialValues( 'dateFrom', 'dateFrom')
               formSchema.value.dateFrom = yup.date()
                  .required('Dato Requerido!')
                  .typeError('Fecha Inválida!')
            }
            if (field == 'valid_until' && !( dataFiels.value.requestFrom && !dataFiels.value.byHand)) {
               //initialFormValues.value[key] = dataFiels.value[value]
               addInitialValues( 'dateUntil', 'dateUntil')
               if ( dataFiels.value.isValid ) {
                  if ( dataFiels.value.byHand ) {
                     if ( dataFiels.value.untilTypeTime == "" ) {
                        formSchema.value.dateUntil = yup.date()
                           .required('Dato Requerido!')
                           .typeError('Fecha Inválida!')
                     } else {
                        let controlUntilDate = moment(dataFiels.value.requestDate).add( dataFiels.value.untilNumberOf, dataFiels.value.untilTypeTime )
                        formSchema.value.dateUntil = yup.date()
                           .required('Dato Requerido!')
                           .typeError('Fecha Inválida!')
                           .max( controlUntilDate, 'La Fecha no debe ser posterior al ' + controlUntilDate.format('DD-MM-YYYY') + '!')
                     }
                  } else {
                     if ( dataFiels.value.fixedDate != "" ) {
                        let untilDate = moment( dataFiels.value.fixedDate ).format('YYYY-MM-DD')
                        //console.log(untilDate)
                        //console.log(initialFormValues.value.dateUntil)
                        if ( initialFormValues.value.dateUntil == null ) {
                           initialFormValues.value.dateUntil = untilDate
                        }
                        formSchema.value.dateUntil = yup.date()
                           .required('Dato Requerido!')
                           .typeError('Fecha Inválida!')
                           .max( untilDate, 'Fecha mayor al ' + untilDate + '!')
                           .min( untilDate, 'Fecha menor al ' + untilDate + '!')
                     } else {
                        formSchema.value.dateUntil = yup.date()
                           .required('Dato Requerido!')
                           .typeError('Fecha Inválida!')
                     }
                  }
               } else {
                  formSchema.value.dateUntil = yup.date()
                     .required('Dato Requerido!')
                     .typeError('Fecha Inválida!')
               }
            }
            if (field == 'requestMedProv' && oStartedBy.value != 'AFL') {
               console.log(dataFiels.value.requestMedProvId)
               if ( dataFiels.value.requestMedProvId === undefined || 
                     dataFiels.value.requestMedProvId == null ) {
                  addInitialValues( 'codeRequestMedProv', 'codeRequestMedProv')
                  formSchema.value.codeRequestMedProv = 'dfrCodeRequestMedProv'
               } else {
                  AnalyService.getMedicalProvider( dataFiels.value.requestMedProvId )
                  .then(response => {
                     console.log(response.data)
                     objReqMedProv.value = response.data
                     medProvEmail.value = objReqMedProv.value.email
                     addInitialValues( 'codeRequestMedProv', 'codeRequestMedProv')
                     nextTick(() => {
                        //formSchema.value.codeRequestMedProv = yup.string().required('Dato Requerido!')
                        formSchema.value.codeRequestMedProv = 'dfrCodeRequestMedProv'
                     })
                  })
                  .catch(error => {
                     console.log(error);
                  })
               }
            }
            if ( field == 'medProv_email' && oStartedBy.value != 'AFL' ) {
               addInitialValues( 'mpEmail', 'medicalProviderEmail')
               formSchema.value.mpEmail = yup.string()
                  .email('Dirección de email inválida!')
                  .required('Dato Requerido!')
            }
            // designated
            if (field == 'designatedMedProv') {
               console.log(dataFiels.value.designatedMedProvId)
               if ( dataFiels.value.designatedMedProvId === undefined || 
                     dataFiels.value.designatedMedProvId == null ) {
                  addInitialValues( 'codeDesignatedMedProv', 'codeDesignatedMedProv')
                  formSchema.value.codeDesignatedMedProv = 'dfrCodeDesignatedMedProv'
               } else {
                  AnalyService.getMedicalProvider( dataFiels.value.designatedMedProvId )
                  .then(response => {
                     console.log(response.data)
                     objDesMedProv.value = response.data
                     addInitialValues( 'codeDesignatedMedProv', 'codeDesignatedMedProv')
                     nextTick(() => {
                        formSchema.value.codeDesignatedMedProv = 'dfrCodeDesignatedMedProv'
                     })
                  })
                  .catch(error => {
                     console.log(error);
                  })
               }
            }

            if ( fieldFocus == '' && firstField ) {
               fieldFocus = field
            }        //confirm
         }

         //
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            myCircle.value = response.data
         })
         .catch(error => { console.log(error) })
         //
      }

      function findMedProv( code, typeMed ) {
         typeMedProv.value = typeMed
         textToSearch.value = code
         optionIndex.value = 1
         if ( code == '' ) {
            optionIndex.value = 0
         }
         searchMedProv.value = true
      }

      async function formSubmit( values ) {
         console.log('Done: ', JSON.stringify(values, null, 2))
         /*
         if ( dataFiels.value.isValid) {
            if ( !confirm("¡La Fecha Desde es mayor a la Fecha de Solicitud!\nSi está correcto presione Aceptar para confirmar.") ) {
               return
            }
         }
         */
         dataForm.value = {}
         dataForm.value.fieldsToUpdate = []
         if ( oDataFromCard.value.typeForm == 'T' ) {
            title.value = ""
            let titleParts = JSON.parse(oCardType.value.titleParameters).output
            let separator = ""
            for (let part of titleParts) {
               if ( part[0] == 'afl' ) {
                  if ( part[1].get == 'name' ) {
                     title.value += separator + dataAffil.value.name
                  }
                  if ( part[1].get == 'cuil' ) {
                     title.value += separator + values.cuil
                     dataForm.value[part[1].update] = values.cuil
                     dataForm.value.fieldsToUpdate.push(part[1].update)
                  }
                  if ( part[1].get == 'location' ) {
                     title.value += separator + dataAffil.value.provinceState
                  }
               }
               if ( part[0] == 'afl_email' && oStartedBy.value != 'MPV' ) {
                     let aflEmailOk = ''
                     if ( values.aflEmail != null ) {
                        aflEmailOk = values.aflEmail
                     }
                     title.value += separator + aflEmailOk
                     dataForm.value[part[1].update] = values.aflEmail
                     dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               if ( part[0] == 'date_req' ) {
                  if ( values.requestDate != null ) {
                     title.value += separator + values.requestDate.replaceAll("-","")
                  }
                  dataForm.value[part[1].update] = values.requestDate
                  dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               if ( part[0] == 'reference' ) {
                     title.value += separator + values.reference
               }
               if ( part[0] == 'txt_free' ) {
                  if ( values.textFree !== undefined && values.textFree !== null ) {
                     title.value += separator + values.textFree
                     dataForm.value[part[1].update] = values.textFree
                     dataForm.value.fieldsToUpdate.push(part[1].update)
                  }
               }
               if ( part[0] == 'requestMedProv' && oStartedBy.value != 'AFL' ) {
                     title.value += separator + objReqMedProv.value.fantasyName
                     dataForm.value[part[1].update] = objReqMedProv.value.id
                     dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               if ( part[0] == 'medProv_email' && oStartedBy.value != 'AFL' ) {
                     title.value += separator + values.mpEmail
                     dataForm.value[part[1].update] = values.mpEmail
                     dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               // designated
               if ( part[0] == 'designatedMedProv' ) {
                     title.value += separator + objDesMedProv.value.fantasyName
                     dataForm.value[part[1].update] = objDesMedProv.value.id
                     dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               //separator = ' | '
               separator = '-|-'
            }
            showTitle.value = true
         }
         if ( oDataFromCard.value.typeForm == 'F' ) {
            if ( values.dateUntil < values.dateFrom ) {
               alert("¡La Fecha Desde es mayor a la Fecha Hasta!")
               return
            }
            console.log(dataFiels.value.requestDate)
            if ( values.dateUntil != null && values.dateUntil < dataFiels.value.requestDate ) {
               alert("¡La Fecha Hasta es menor a la Fecha de Solicitud!")
               return
            }
            if ( values.dateFrom > dataFiels.value.requestDate ) {
               if ( !confirm("¡La Fecha Desde es mayor a la Fecha de Solicitud!\nSi está correcto presione Aceptar para confirmar.") ) {
                  return
               }
            }
            let formParts = JSON.parse(oDataFromCard.value.formParameters).output
            console.log(formParts)
            for (let part of formParts) {
               // req medical provider
               if ( part[0] == 'requestMedProv' && oStartedBy.value != 'AFL' ) {
                  dataForm.value[part[1].update] = objReqMedProv.value.id  //values.requestMedProvId
                  dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               // des medical provider
               if ( part[0] == 'designatedMedProv' ) {
                  dataForm.value[part[1].update] = objDesMedProv.value.id  
                  dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               // auth
               if ( part[0] == 'authorization' ) {
                  dataForm.value[part[1].update] = values.authorization
                  dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               // valid
               if ( part[0] == 'valid_from' ) {
                  dataForm.value[part[1].update] = values.dateFrom
                  dataForm.value.fieldsToUpdate.push(part[1].update)
               }
               if ( part[0] == 'valid_until' ) {
                  dataForm.value[part[1].update] = values.dateUntil
                  if ( dataFiels.value.isValid ) {
                     if ( !dataFiels.value.requestFrom && dataFiels.value.typeTime != '' ) {
                        dataForm.value[part[1].update] = moment(values.dateUntil).add( dataFiels.value.numberOf, dataFiels.value.typeTime )
                     }
                     /*
                     if ( dataFiels.value.requestFrom && dataFiels.value.typeTime != '' ) {
                        dataForm.value[part[1].update] = moment(values.dateFrom).add( dataFiels.value.numberOf, dataFiels.value.typeTime )
                     }
                     */
                     if ( dataFiels.value.requestFrom && dataFiels.value.typeTime != '' ) {
                     //if ( dataFiels.value.requestFrom && typeTime != '' ) {
                        //
                        //console.log(JSON.stringify(dataFiels.value, null, 2))
                        let typeTime = dataFiels.value.typeTime
                        let numberOf = dataFiels.value.numberOf
                        if ( typeTime == '*' ) {
                           let validUntilTime =  await findValidUntilDate( values.dateFrom )
                           console.log(JSON.stringify(validUntilTime, null, 2))
                           typeTime = validUntilTime.typeTime
                           numberOf = validUntilTime.numberOf
                        }
                        //
                        dataForm.value[part[1].update] = moment(values.dateFrom).add( numberOf, typeTime )
                     }
                     //moment(new Date()).subtract(1, 'month')
                  }
                  dataForm.value.fieldsToUpdate.push(part[1].update)
               }
            }
            console.log(JSON.stringify(dataForm.value, null, 2))
            //updateForm( oDataFromCard.value.cardId, 'Form' )
            //beforeClose()
            typeUpForm = 'Form'
            doNotClose.value = true
         }
      }

      function newUpForm() {

         let newDataForm = {}
         if ( typeUpForm == 'New' ) {
            console.log('Alta Titulo Iniciada!!')
            /*
            */
            let addCntt = {}
               addCntt.userId = currentUserId.value, // userId,
               addCntt.boardId = boardId.value,       // boardId, 
               addCntt.cellId = props.cellId,        // cellId,
               addCntt.cardTypeId = oCardType.value.id,  // cardTypeId,
               addCntt.title = title.value          // title

            newDataForm.addContentRequest = addCntt

            newDataForm.upTheForm = true
         }
         if ( typeUpForm == 'Update' ) {
            console.log('Modificacion Titulo Iniciada!!')
            let cnttReq = {}
               cnttReq.contentId = oDataFromCard.value.cardId
               cnttReq.cellId = oDataFromCard.value.cellId
               cnttReq.boardId = boardId.value
               cnttReq.columnId = 0
               cnttReq.userId = currentUserId.value
               cnttReq.title = title.value

            newDataForm.contentRequest = cnttReq

            newDataForm.upTheForm = ( dataFiels.value.title.trim() !== title.value.trim() )

         }
         if ( typeUpForm == 'Form' ) {
            console.log('Actulización Formulario Boton Iniciada!!')
            newDataForm.upTheForm = true
         }               
         setDataForm( oDataFromCard.value.cardId, typeUpForm )
         newDataForm.upFormRequest = dataForm.value

         WspService.upForm( newDataForm )
         .then( response => {
            console.log( response.data )
            if ( typeUpForm == "New" ) {
               contentId.value = response.data[0]
               cellContentId.value = response.data[1]
            }
            if ( typeUpForm == "Update" ) {
               if ( response.data[0] > 0 ) {
                  store.dispatch("wspace/setContentId", -16)
               }
            }
            if ( typeUpForm == "Form" ) {
               if ( oDataFromCard.value.extensionCode == 'VALID' ) {
                  store.dispatch("wspace/setContentId", -15)
               }
               if ( oDataFromCard.value.extensionCode == 'AUTH' ) {
                  store.dispatch("wspace/setContentId", -19)
               }
               if ( oDataFromCard.value.extensionCode == 'MPRQ' ) {
                  store.dispatch("wspace/setContentId", -20)
               }
               if ( oDataFromCard.value.extensionCode == 'MPDS' ) {
                  store.dispatch("wspace/setContentId", -21)
               }
            }
         })
         .catch( error => { 
            console.log(error) 
            alert('Se ha producido el siguiente ' + error)
         } )
         .finally( () => { 
            doNotClose.value = false
            if ( typeUpForm == 'New' ) {
               console.log('Alta Titulo Finalizada!!') 
               btnEdit.value.click() 
               emit('cancel')
            }
            if ( typeUpForm == 'Update' ) {
               console.log('Modificacion Titulo Finalizada!!') 
               beforeClose()
            }
            if ( typeUpForm == 'Form' ) {
               console.log('Actulización Formulario Boton Finalizada!!') 
               beforeClose()
            }
         })
      }

      function getCardType() {
         return new Promise( (resolve) => {
            oDataFromCard.value = JSON.parse( props.dataFromCard )
            console.log( oDataFromCard.value.typeForm )
            if ( oDataFromCard.value.typeForm == null ) {
               oDataFromCard.value.typeForm = 'T'
            }
            console.log( oDataFromCard.value.typeForm )
            if ( oDataFromCard.value.cardId == 0 ) {
               resolve ( props.cardType )
            } else {
               WspService.getMyCardRectangle( oDataFromCard.value.cardTypeID )
               .then(response => { resolve ( response.data ) })
               .catch(error => { console.log(error) });
            }
         })
      }

      function getFormValues() {
         return new Promise( (resolve) => {
            WspService.getFormValues( oDataFromCard.value.cardId )
            .then(response => { resolve ( response.data )})
            .catch(error => { console.log(error) })
         })
      }

      function findValidUntilDate( date ) {
         return new Promise( (resolve) => {
            WspService.findValidUntilDate( date )
            .then(response => { resolve ( response.data )})
            .catch(error => { console.log(error) })
         })
      }

      function opened() {
         nextTick(() => {
            if ( fieldFocus != '' ) {
               document.getElementById(fieldFocus).focus()
            }
         })
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      function upCuil( cuil ) {
         searchAffil.value = false
         newCuilValue.value = cuil
         changeCuilValue.value = true
         nextTick(() => {
            document.getElementById('afl').focus()
            changeCuilValue.value = false
         })
      }

      function upItemMedProv( value ) {
         searchMedProv.value = false
         if ( typeMedProv.value == 'Req' ) {
            objReqMedProv.value = value
            newCodeReqMedProvValue.value = value.sCode
            changeCodeReqMedProvValue.value = true
         }
         if ( typeMedProv.value == 'Des' ) {
            objDesMedProv.value = value
            newCodeDesMedProvValue.value = value.sCode
            changeCodeDesMedProvValue.value = true
         }
         nextTick(() => {
            if ( typeMedProv.value == 'Req' ) {
               document.getElementById('requestMedProv').focus()
               changeCodeReqMedProvValue.value = false
            }
            if ( typeMedProv.value == 'Des' ) {
               document.getElementById('designatedMedProv').focus()
               changeCodeDesMedProvValue.value = false
            }
            // okCodeReqMedProv.value == true
         })
         /*
         searchAffil.value = false
         newCuilValue.value = cuil
         changeCuilValue.value = true
         nextTick(() => {
            document.getElementById('afl').focus()
            changeCuilValue.value = false
         })
         */
      }

      function upEmail( email, focus  ) {
         newEmailValue.value = email
         changeEmailValue.value = true
         nextTick(() => {
            if ( focus ) {
               document.getElementById('afl_email').focus()
            }
            changeEmailValue.value = false
         })
      }

      function upMedProvEmail( email, focus  ) {
         newMedProvEmailValue.value = email
         changeMedProvEmailValue.value = true
         nextTick(() => {
            if ( focus ) {
               document.getElementById('medProv_email').focus()
            }
            changeMedProvEmailValue.value = false
         })
      }

      function upReference() {
         newReferenceValue.value = ''

         if ( oCardType.value.referenceType == 'ID' ) {
            //newReferenceValue.value = cardTypeReferences.value[0].name
            newReferenceValue.value = cardTypeReferences.value[0].titleName
            cardTypeReferences.value[0].selected = true
         }
         /*
         if ( oCardType.value.referenceType == 'OC' ) {
            for (let reference of cardTypeReferences.value) {
               if ( reference.selected ) {
                  newReferenceValue.value = reference.code
               }
            }
         }
         */
         if ( oCardType.value.referenceType == 'ON' ) {
            for (let reference of cardTypeReferences.value) {
               if ( reference.selected ) {
                  //newReferenceValue.value = reference.name
                  newReferenceValue.value = reference.titleName
               }
            }
         }
         if ( oCardType.value.referenceType == 'MN' ) {
            let separator = ''
            for (let reference of cardTypeReferences.value) {
               if ( reference.selected ) {
                  //newReferenceValue.value += separator + reference.name
                  newReferenceValue.value += separator + reference.titleName
                  separator = '-:-'
               }
            }
         }
         /*
         if ( oCardType.value.referenceType == 'MC' ) {
            let separator = ''
            for (let reference of cardTypeReferences.value) {
               if ( reference.selected ) {
                  newReferenceValue.value += separator + reference.code
                  separator = ' '
               }
            }
         }
         */

         if ( newReferenceValue.value != '' ) {
            changeReferenceValue.value = true
            nextTick(() => {
               changeReferenceValue.value = false
               searchReference.value = false
            })
         }
      }

      async function validAffil( value ) {

         let validAff = await validCuilAffil( value )
         if ( typeof( validAff ) == "boolean" ) {

            let basicData = await findBasicAffilData( value )
            if ( typeof( basicData ) == "boolean" ) {
               return 'Error de red!'
            }
            dataAffil.value = basicData
            validCuil.value = true
            affilId.value = value
            affilEmail.value = dataAffil.value.email
            return true
         }
         affilId.value = 0
         return validAff
      }
      
      return {
         affilEmail, affilId,
         beforeClose, beforeOpen, btnEdit, btnSubmitName,
         cardTypeReferences, cellContentId, contentId,
         changeCodeReqMedProvValue, changeCodeDesMedProvValue, changeCuilValue, changeEmailValue, changeMedProvEmailValue, changeReferenceValue,
         dataAffil, dataFiels, dataForm, doNotClose,
         fieldArray, findMedProv, formCnf, formSchema, formSubmit,
         initialFormValues, inputFormModal,
         medProvEmail, myCircle,
         newCodeReqMedProvValue, newCodeDesMedProvValue, newCuilValue, newEmailValue, newMedProvEmailValue, newReferenceValue, newUpForm,
         objReqMedProv, objDesMedProv, oCardType, oDataFromCard, okCodeReqMedProv, optionIndex, 
         onBlurCuit, onBlurReqMedProv, onBlurDesMedProv, opened, oStartedBy,
         reqMedProvId,
         searchAffil, searchEmail, searchMedProv, searchMedProvEmail, searchReference, showTitle,
         tabIndexNumber, textToSearch, title, typeMedProv,
         upCuil, upEmail, upItemMedProv, upMedProvEmail, upReference, upTitle,
         validCuil
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.input-form-modal-content) {
  /*
  width: 350px;
  max-width: 450px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 550px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
::v-deep(.v310-modal-content) {
  /*
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 300px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.multi-card {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.tj-foot-cell {
   cursor: pointer;
}
.tj-foot-cell:hover {
   background-color: darkgrey;
}
</style>
